export default {
  archDestructionDetail: {
    component: () =>
      import(
        "@/mods/archive/archDestructionManage/detailView/ArchDestructionDetail"
      ),
  },
};
